import { Grid, styled } from '@mui/material';

const PREFIX = 'FirmForm';

export const classes = {
  formHeader: `${PREFIX}-formHeader`,
  margin: `${PREFIX}-margin`,
  textField: `${PREFIX}-textField`,
  autocomplete: `${PREFIX}-autocomplete`,
  checkbox: `${PREFIX}-checkbox`,
};

export const StyledGrid = styled(Grid)({
  [`& .${classes.formHeader}`]: {
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  [`& .${classes.margin}`]: {
    marginBottom: 20,
  },
  [`& .${classes.textField}`]: {
    width: '100%',
  },
  [`& .${classes.autocomplete}`]: {
    zIndex: 1300,
  },
  [`& .${classes.checkbox}`]: {
    margin: '0.5rem 0',
  },
});